var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"item ripple",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_c('div',[_c('div',{staticClass:"titulo"},[_vm._v(_vm._s(_vm.titulo))])])])}
var staticRenderFns = []

export { render, staticRenderFns }